module.exports = require("@sentry/node");